import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let playbutton = document.querySelector('[paws-component="noss-elearning"][paws-template="details"] img.playbtn');
    if (playbutton !== undefined) {
        playbutton.addEventListener('click', function (event) {
            let video = event.target.closest('.videocontainer').querySelector('video');

            let quiz = document.querySelector('[paws-component="noss-elearning"][paws-template="details"] .quiz');
            if (quiz !== undefined) {
                video.addEventListener("ended", function (event) {
                    quiz.classList.add('active');
                });
            }

            event.target.closest('.videocontainer').classList.remove('inactive');
            video.play();
        });
    }
}
